<template>
  <div class="myContianer">
      <a-select
        show-search
        placeholder="省"
        option-filter-prop="children"
        style="width: 120px"
        :filter-option="filterOption"
        @focus="handleProvinceFocus"
        @blur="handleProvinceBlur"
        @change="handleProvinceChange"
        v-model="province"
      >
        <a-select-option v-for="item in provinceList" :key="item.id" :value="item.value"> {{item.label}} </a-select-option>
      </a-select>
      <a-select
        show-search
        placeholder="市"
        option-filter-prop="children"
        style="width: 120px;margin:0px 5px"
        :filter-option="filterOption"
        @focus="handleCityFocus"
        @blur="handleCityBlur"
        @change="handleCityChange"
        v-model="city"
      >
        <a-select-option v-for="item in cityList" :key="item.id" :value="item.value"> {{item.label}} </a-select-option>
      </a-select>
       <a-select
        show-search
        placeholder="区 / 县"
        option-filter-prop="children"
        style="width: 120px"
        :filter-option="filterOption"
        @focus="handleCountyFocus"
        @blur="handleCountyBlur"
        @change="handleCountyChange"
        v-model="county"
      >
        <a-select-option v-for="item in countyList" :key="item.id" :value="item.value"> {{item.label}} </a-select-option>
      </a-select>
  </div>
</template>
<script>
import { cityOptions } from '@/utils/enumeration.js'
export default {
  created(){
    this.provinceList = cityOptions
  },
  data(){
    return {
      provinceList:null,
      cityList:null,
      countyList:null,
      province:'',
      city:'',
      county:'',
    }
  },
  methods: {
    //处理省下拉框
    handleProvinceChange(value) {
      this.cityList = this.provinceList.find(item => item.value === value).children
    },
    handleProvinceFocus() {
     this.cityList=null
     this.countyList=null
     this.city = '',
     this.county = ''
    },
   handleProvinceBlur(){
       if(this.provinceList.find(item => item.value === this.province).label){
           this.province = this.provinceList.find(item => item.value === this.province).label
       }
     this.$emit('handleProvinceCity',`${this.province}${this.city}${this.county}`)
   },
    //处理市下拉框
    handleCityChange(value) {
        this.countyList = this.cityList.find(item => item.value === value).children
    },
    handleCityFocus() {
       this.county = ''
       this.countyList=null
    },
    handleCityBlur(){
        if(this.cityList.find(item => item.value === this.city).label){
             this.city = this.cityList.find(item => item.value === this.city).label
        }
    
     this.$emit('handleProvinceCity',`${this.province}${this.city=='市辖区' || this.city=='县'?'':this.city}${this.county}`)
   },
    //处理县区
    handleCountyChange(value) {
      console.log(`selected ${value}`);
    },
      handleCountyBlur(){
       if(this.countyList.find(item => item.value === this.county).label){
                this.county = this.countyList.find(item => item.value === this.county).label
       }
       this.$emit('handleProvinceCity',`${this.province}${this.city=='市辖区' || this.city=='县'?'':this.city}${this.county}`)
   },
   handleCountyFocus(){

   },
    filterOption(input, option) {
      console.log(input,option)
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
  },
};
</script>
<style lang="less" scoped>
  .title{
    width: 100%;
    height: 50px;
    line-height: 50px;
    margin-top:20px;
  }
  .myCascader{
    width: 500px;
    height: 300px;
    border:1px solid #ccc;
    border-radius: 5px;
    margin:20px 50px;
    text-align: left;
    padding:20px;
    box-sizing: border-box;
  }
</style>